import React from "react";
import { useState, useEffect } from 'react';
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import UpdateDialog from "./components/UpdateDialog";
import { Provider } from "react-redux";
import { store } from "./store/store";
// import { reducers } from "./reducers/reducers";
// import { applyMiddleware, createStore } from 'redux';
// import logger from 'redux-logger'

import { ThemeProvider } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import firebase from "./firebase";
import { useSelector, useDispatch } from "react-redux";
import { changeIsPaid } from "./actions/actions.js";
import { setNeedEmailVerify, setZlaboPremium } from "./actions/actions.js";

import * as ServiceWorkerRegistration from "./serviceWorkerRegistration";
import * as Sentry from "@sentry/react";
import reportWebVitals from "./reportWebVitals";
import styled from 'styled-components'
import { CircularProgress } from '@material-ui/core';

Sentry.init({
  dsn:
    "https://257195aa30e5446e98a52df54bd7f7f6@o400603.ingest.sentry.io/5397747",
});

// const store = createStore(
//   reducers,
//   applyMiddleware(logger)
// );


const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#007DB3",
      main: "#415EA6",
    },
    secondary: {
      main: "#006699",
    },
  },
});

const CheckPaid = () => {
  const dispatch = useDispatch();
  const [isLoading, switchLoading] = useState(false);
  const isPaid = useSelector((state) => state.user.isPaid);
  // const zlaboPremium = useSelector((state) => state.user.zlaboPremium);
  // const [zlaboPremium, setZlaboPremium] = useState(false);

  const Background = styled.div`
        background-color:  rgba(255,255,255,0.5);
        width: 100%;
        height: 100%;
        position: absolute;
    `;

  const Wrapper = styled.div`
    text-align: center;
    margin-top: 200px;
  `;


  const Loading = () => {
    return (
      <Background>
        <Wrapper>
          <CircularProgress />
        </Wrapper>
      </Background>
    );
  }


  useEffect(() => {
    const unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        switchLoading(true);
        const db = firebase.firestore();
        db.collection(`/customers/${user.uid}/subscriptions`)
          .where('status', 'in', ['trialing', 'active'])
          .where("current_period_end", ">", new Date())
          .get()
          .then(async (qs) => {
            const isValid = !qs.empty;

            await firebase.auth().currentUser.reload();
            // console.log("emailverified:", emailVerified);
            const emailVerified = user.emailVerified;

            if (isValid) {
              dispatch(changeIsPaid(true));
              db.collection('customers')
                .doc(user.uid)
                .onSnapshot(async (snapshot) => {
                  const zlabo_premium = snapshot.data().zlabo_premium;
                  // console.log("snaphsot on index.js: ", zlabo_premium);
                  // console.log("zlabopremiu on index.js: ", snapshot.data());

                  if (zlabo_premium && emailVerified) {
                    // console.log("index.js 1")
                    dispatch(setNeedEmailVerify(false));
                  } else if (zlabo_premium && !emailVerified) {
                    // console.log("index.js 2")
                    dispatch(setNeedEmailVerify(true));
                  } else {
                    // console.log("index.js 3")
                    dispatch(setNeedEmailVerify(false));
                  }
                });
              switchLoading(false);
            } else {
              dispatch(changeIsPaid(false));
              switchLoading(false);
            }
          });
      } else {
        dispatch(changeIsPaid(false));
        switchLoading(false);
      }
    });
    return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
  }, []);

  return (isLoading ? <Loading /> : null);
};


ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CheckPaid />
      <div className="update-dialog"></div>
      <App />
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);


ServiceWorkerRegistration.register({
  onUpdate: (registration) => {
    //console.log("registration:", registration);
    //console.log("update start");
    ReactDOM.render(
      <UpdateDialog registration={registration} />,
      document.querySelector(".update-dialog")
    );
  },
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
